import React, { useState,useEffect,useRef } from "react";
import { AutoComplete } from 'primereact/autocomplete';
import { Toast } from 'primereact/toast';

const SeleccionRegistradoresAdmin = (props) => {
console.log(props);
 const [selectedAutoValue, setSelectedAutoValue] = useState(props.NOMREGISTRADOR);
  const [autoFilteredValue, setAutoFilteredValue] = useState([]);
  const [autoValue, setAutoValue] = useState(null);
  const [reload, setReload] = useState(true)
  const toast = useRef(null);
  const APITABLASBASICAS = 'https://www.ancogenecop.com/APIANCO/controllers/selecciones.php?op='

  useEffect(() => {
    if(props.tidRegistrador=='' || props.tidRegistrador==undefined) return
    setAutoValue([])
    setReload(false)
    async function traerUsuarios(tidRegistrador) {
      const data = new FormData();
      data.append("TID_TERCERO",tidRegistrador)
      data.append("NID_TERCERO",localStorage.getItem('nid_propietario'))
      await fetch(APITABLASBASICAS + 'seleccionRegistradoresAdmin', {
        method: 'POST',
        header: {
          'Accept': 'application/json',
          'Content-type': 'application/json'
        },
        body: data
      }).then((response) => response.json())
        .then((response) => {
            setAutoValue(response)
        })
        .catch((error) => {
          console.log(error);
        })
    }
        traerUsuarios(props.tidRegistrador)
  }, [reload,props.tidRegistrador]);

//   function sleep(ms) {
//     return new Promise(resolve => setTimeout(resolve, ms));
// }

  const searchCountry = (event) => {
    setTimeout(() => {
        if (!event.query.trim().length) {
            setAutoFilteredValue([...autoValue]);
        }
        else {
            setAutoFilteredValue(autoValue.filter((a) => {
                return a.name.toUpperCase().startsWith(event.query.toUpperCase());
            }));
        }
    }, 250);
};



  const handleChange = (event) => {
    setSelectedAutoValue(event)
        return props.handleplanta(event.code,props.opcion) 
  };

  // const handleClick = (event) => {
  //   return props.handleplanta('',1000)
  // };


  return (
      <div className="p-error">
      <Toast ref={toast} />
      <AutoComplete placeholder="Buscar" id="dd" dropdown value={selectedAutoValue}
      onChange={(e) => handleChange(e.value)}
      suggestions={autoFilteredValue} completeMethod={searchCountry} field="name" />
    </div>
  );
};

export default SeleccionRegistradoresAdmin;
